import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Parse  from '../../../Parse';

import * as actions from '../../../store/actions/index';

class Logout extends Component {
    componentDidMount () {
        Parse.User.logOut().then(() => {
            this.props.onLogout(); 
        });
    }

    render () {
        return <Redirect to="/login"/>;
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onLogout: () => dispatch(actions.logout())
    };
};

export default connect(null, mapDispatchToProps)(Logout);